/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    // editor
    locale_en_gb,
    createDefaultImageReader,
    createDefaultImageWriter,

    // plugins
    setPlugins,
    plugin_crop,
    plugin_crop_locale_en_gb,
    plugin_crop_defaults,
    plugin_finetune,
    plugin_finetune_locale_en_gb,
    plugin_finetune_defaults,
    plugin_decorate,
    plugin_decorate_defaults,
    plugin_decorate_locale_en_gb,
    component_shape_editor_locale_en_gb,
} from 'doka';

const SET_PLUGINS = [plugin_crop, plugin_finetune, plugin_decorate];

export const setEditorPlugins = () => setPlugins(...SET_PLUGINS);

const plugin_decorate_defaults_custom = { ...plugin_decorate_defaults };
delete plugin_decorate_defaults_custom['decorateToolShapes']['sharpie'];
plugin_decorate_defaults_custom['decorateTools'].splice(0, 2);
plugin_decorate_defaults_custom['decorateTools'].splice(plugin_decorate_defaults_custom['decorateTools'].length - 1, 1);

export const getEditorDefaults = (targetSize = null) => {
    return {
        imageReader: createDefaultImageReader(),
        imageWriter: createDefaultImageWriter({ quality: 0.80, targetSize: targetSize && Object.keys(targetSize).length ? targetSize : { width: 300, heigth: 300 } }),
        cropEnableButtonFlipVertical: true,
        cropEnableButtonRotateRight: true,
        ...plugin_crop_defaults,
        ...plugin_finetune_defaults,
        // ...plugin_decorate_defaults,
        ...plugin_decorate_defaults_custom,
        locale: {
            ...locale_en_gb,
            ...plugin_crop_locale_en_gb,
            ...plugin_finetune_locale_en_gb,
            ...plugin_decorate_locale_en_gb,
            ...component_shape_editor_locale_en_gb,
            labelButtonExport: 'Save'
        }
    };
};

/* provides a circle crop layout (suitable for profile image) */
export const circleCropMask = (shapes, state) => {
    const { utilVisibility, selectionRect } = state;

    // exit if crop utils is not visible
    if (utilVisibility.crop <= 0) return shapes;

    // shortcuts to selection rect
    const { x, y, width, height } = selectionRect;

    // return updated shapes
    return {
        // copy props from shapes param
        ...shapes,

        // add an `ellipse` shape
        interfaceShapes: [
            {
                x: x + width * 0.5,
                y: y + height * 0.5,
                rx: width * 0.5,
                ry: height * 0.5,
                opacity: utilVisibility.crop,
                inverted: true,
                backgroundColor: [0, 0, 0, 0.5],
                strokeWidth: 1,
                strokeColor: [0, 0, 0],
            },
            ...shapes.interfaceShapes,
        ],
    };
};
